import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/location/agra")({
  beforeLoad: () => {
    throw redirect({ to: "/locations/agra", replace: true, statusCode: 301 });
  },
});
